let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("1susf")).then(() => parcelRequire('6kAMA'));